import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { Link } from "react-router-dom";
import { getFriendlyDateFormat } from "../../utility/index";
import { convertDateToMonthDayYYYY } from "../../utility/index";
import FontAwesome from "react-fontawesome";
import "./blogcard.css";

import React from "react";

const BlogDetails = ({
  id,
  title,
  description,
  category,
  userId,
  author,
  timestamp,
  user,
  handleDelete,
}) => {
  return (
    <Card className="border-0 blog-card-wrapper">
      <Card.Body className="p-0 my-card">
        <div className="blog-card-category">{category}</div>
        <Card.Title className="blog-card-title">{title}</Card.Title>
        <div className="blog-card-meta">
          <span className="blog-card-author">{author}</span>
          <span>•</span>
          <span>{getFriendlyDateFormat(timestamp.toDate().toString())}</span>
        </div>
        <div
          className="blog-card-description"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Link to={`/detail/${id}`} style={{ textDecoration: "none" }}>
            <span className="my-card-link">Read More →</span>
          </Link>
          {user && user.uid === userId && (
            <div className="blog-card-actions">
              <FontAwesome
                name="trash"
                style={{
                  cursor: "pointer",
                  color: "#ef4444",
                  transition: "all 0.3s ease",
                  fontSize: "20px",
                }}
                onClick={() => handleDelete(id)}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              />
              <Link to={`/update/${id}`}>
                <FontAwesome
                  name="edit"
                  style={{
                    cursor: "pointer",
                    color: "#f59e0b",
                    transition: "all 0.3s ease",
                    fontSize: "20px",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.transform = "scale(1.1)")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                />
              </Link>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default BlogDetails;
